import {
  CreateCompanyRequest,
  CreateCompanyResponse,
  ParamsToFilterReferringCompanies,
} from '@/modules/leadIndication/entities/leadIndication.interface';
import HttpClientAdapter from '@/shared/services/httpClientAdapter';

/**
 * Serviço de integração com a API de Elegibilidade para o fluxo de Indicações.
 *
 * As empresas indicadoras são consultadas e criadas na API de Elegibilidade.
 * A listagem do histórico é feita pela API de monitoring
 * (`LeadIndicationService`) e o upload do arquivo pela API de Files
 * (`FilesService`). Não há endpoint de validação separado: os erros de
 * validação são retornados na própria resposta de erro do upload.
 */
class EligibilityService extends HttpClientAdapter {
  constructor() {
    super('ELIGIBILITY');
  }

  getReferringCompanies<Response>(params?: Partial<ParamsToFilterReferringCompanies>) {
    return this.get<Response>('/vitta-subscription/referring-companies', params);
  }

  createReferringCompany(params: CreateCompanyRequest) {
    return this.post<CreateCompanyResponse>('/vitta-subscription/referring-companies', params);
  }
}

export default EligibilityService;
